import { css, type Theme } from '@emotion/react';

import { removeButtonAppearance } from '@didaskill/ui/design-system';

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 10px;

  border-radius: 8px;
  padding: 10px;
`;

export const alertContent = css`
  display: flex;
  gap: 20px;
`;

export const link = (theme: Theme) => css`
  ${removeButtonAppearance}
  color: ${theme.colors.primary[500]};
`;
